<template>
	<div>
        <el-upload
          class="upload"
          name="excel"
          action="/apis/excel.php"
          :data="uploadData"
          :before-upload='upBefore'
          :on-success='upScuccess'
          :on-error='upError'
          ref="upload"
          style="float: left;margin-right: 20px">
          <el-button size="medium" type="success" id="imgInput" round element-loading-text="插入中,请稍候">上传EXCEL</el-button>
        </el-upload>
	</div>

</template>

<script>
	export default {
	    data() {
	      return {
			uploadData:{
				token:'eqgU1wqtfzcZRAniU',
				admin:this.$store.getters.name,
				my:this.$store.getters.token
			},
	      };
	    },
	    methods: {
			upBefore(file){
				console.log(file.type);
				if(['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/vnd.ms-excel'].indexOf(file.type)==-1) {
					this.$message.error("只能上传xls/xlsx格式");
					return false;
				}
				if(file.size > 8*1024*1024) {
					this.$message.error("文件大小不要超过8M");
					return false;
				}
			},
			upError(err, file, fileList){
				console.log(err);
				this.$message.error('上传失败');
			},
			upScuccess(ret, file, fileList) {
				console.log(ret);
				if (ret.indexOf('token') > -1) {this.$message.error("文件大小不要超过8M");return;}
				if (ret.indexOf('只能上传xls/xlsx格式') > -1) {this.$message.error(ret);return;}
				if (ret.indexOf('导入成功') > -1) {
					this.$message.success(ret);
					this.$emit("rf_exam");
				}else this.$message.error('导入失败');
			},
	    }
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Adde.vue